<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>
        <subNav></subNav>
        <div class="wrap nav-zero">
            <div class="Ir-homepage-body">
                <div class="irpagedata">
                    <p class="nav-zero-title">Corporate Profile</p>
                    <p>
                        <div align="justify" style="line-height: 28px;">MMV is an animation and entertainment company devoted to establishing an open community for its global users and to providing high-quality and immersive entertainment experience by way of original contents and user-generated contents. MMV has created some of the most iconic original animation series, particularly among the younger audience in China, and maintained a large, engaging fan base on social media.
    MMV has developed a business model that centers around its proprietary brands, and creates value from content licensing, developing and operating mobile games, sale of merchandise, all of which to are based on its proprietary contents and brands. The diversified content offerings also provide MMV’s users with intriguing and multi-faceted entertainment services and products.
    MMV has been listed on NASDAQ since [December] 2022, and traded under the ticker symbol “MMV”.
                        </div>
                    </p>
                </div>
                <div class="irqmode-1">
                    <!-- <div data-qmod-tool="detailedquotetabchart" data-qmod-params='{"symbol":"MSFT"}' class="qtool"></div> -->
                    <div data-qmod-tool="quotehead" data-qmod-params='{"symbol":"MMV"}' class="qtool"></div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <!--菜单一内容-->
        <div class="wrap nav-one">
            <div class="title">
                EVENTS & PRESENTATIONS
                <router-link :to="{ path: '/presentations' }">
                    <span class="rl"
                        ><img
                            src="@/assets/investor-Relation/more.png"
                            alt=""
                        /><span class="more">Read more</span></span
                    >
                </router-link>
            </div>
            <ul style="display: none;">
                <li v-for="(item, index) in eventsList" :key="index">
                    <div class="num">{{ index + 1 }}</div>
                    <div>
                        <div class="caption">
                            {{ item.title }}
                        </div>
                        <div class="date">{{ item.datetime }}</div>
                    </div>
                    <div class="pdf">
                        <a :href="item.files_path[0]" target="_blank">
                            <img
                                src="@/assets/investor-Relation/pdf.png"
                                alt=""
                                v-if="getFile(item.files_path[0]) == 'pdf'"
                            />
                            <img
                                src="@/assets/investor-Relation/rar.png"
                                alt=""
                                v-if="
                                    getFile(item.files_path[0]) == 'rar' ||
                                    getFile(item.files_path[0]) == 'zip'
                                "
                            />
                            <img
                                src="@/assets/investor-Relation/rtf.png"
                                alt=""
                                v-if="getFile(item.files_path[0]) == 'rtf'"
                            />
                            <img
                                src="@/assets/investor-Relation/word.png"
                                alt=""
                                v-if="getFile(item.files_path[0]) == 'word'"
                            />
                            <img
                                src="@/assets/investor-Relation/xlsx.png"
                                alt=""
                                v-if="getFile(item.files_path[0]) == 'xlsx'"
                            />
                            <img
                                src="@/assets/investor-Relation/img.png"
                                alt=""
                                v-if="
                                    getFile(item.files_path[0]) == 'jpg' ||
                                    getFile(item.files_path[0]) == 'png'
                                "
                            />
                        </a>
                    </div>
                    <!-- <div class="down">
                        <img src="@/assets/investor-Relation/down.png" alt="" />
                    </div> -->
                </li>
            </ul>
        </div>
        <!--菜单二内容-->
        <div class="nav-two">
            <div class="wrap">
                <div class="title">
                    PRESS RELEASES<span class="rl">
                        <router-link :to="{ path: '/pressReleases' }">
                            <img
                                src="@/assets/investor-Relation/more.png"
                                alt=""
                            /><span class="more">Read more</span>
                        </router-link>
                    </span>
                </div>
                <div class="press" style="display: none;">
                    <!-- <div data-qmod-tool="fullnews" data-qmod-params='{"symbol":"MSFT"}' class="qtool"></div> -->
                    <!-- <div data-qmod-tool="fullnews" data-qmod-params='{"symbol":"MMV", "videonews":false,"showVideos":false, "src":"prn"}' class="qtool"></div> -->
                    <!-- <ul>
                        <li
                            v-for="(item, index) in releasesList"
                            :key="index"
                            :class="{
                                borderNone: releasesList
                                    ? releasesList.length < 3
                                    : '',
                                borderNone2: releasesList
                                    ? releasesList.length < 4
                                    : '',
                            }"
                        >
                            <div class="caption">
                                {{ item.title }}
                            </div>
                            <div class="date">{{ item.datetime }}</div>
                        </li>
                    </ul> -->
                </div>
            </div>
        </div>
        <!--菜单三内容-->
        <div class="wrap nav-three">
            <div class="title">
                REPORTS & FILINGS<span class="rl">
                    <router-link :to="{ path: '/secFilings' }">
                        <img
                            src="@/assets/investor-Relation/more.png"
                            alt=""
                        /><span class="more">Read more</span>
                    </router-link>
                </span>
            </div>
            <div class="reports" style="display: none;">
                <div class="left-content">
                    <div class="caption">NOTICE</div>
                    <div>
                        <ul>
                            <li
                                v-for="(item, index) in reportsList"
                                :key="index"
                            >
                            <router-link :to="{ path: '/formLink' ,query:{id:item.id}}" style="display:flex;">
                                <div class="num">{{ index + 1 }}</div>
                                <div>
                                    <div class="sub-caption">
                                        {{ item.title }}
                                    </div>
                                    <div class="date">{{ item.ctime }}</div>
                                </div>
                            </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right-content">
                    <div class="caption">FINANCIAL REPORT</div>
                    <div class="financial">
                        <div class="time-line">
                            <div class="line">
                                <div class="dot"></div>
                            </div>
                            <span class="date" v-for="(value, key, index) in financial"
                                    :key="index">
                                    <div :style="{marginTop:index*130+'px'}">{{key}}</div>
                                    </span>
                                    
                        </div>
                        <div class="date-year">
                            <ul>
                                <li
                                    v-for="(item, index) in financialList"
                                    :key="index"
                                >
                                    <div>
                                        <span class="current">{{item.time.split('-')[0] }}</span
                                        ><span class="year">year</span>
                                    </div>
                                    <div class="date" >{{item.time}}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--菜单四内容-->
        <div class="nav-four">
            <div class="wrap">
                <div class="title">
                    STOCK PERFORMANCE
                    <!-- <span class="rl"
                        ><img
                            src="@/assets/investor-Relation/more.png"
                            alt=""
                        /><span class="more">Read more</span></span
                    > -->
                </div>
                <div class="update">
                    <div data-qmod-tool="interactivechart" data-qmod-params='{"symbol":"MMV"}' class="qtool"></div>
                </div>
                <!-- <div class="price">
                    <div class="stock">
                        <div class="real">Real time stock price</div>
                        <div>
                            <span class="hkd">HKD</span
                            ><span class="num">451.8</span>
                        </div>
                        <div class="percent">
                            <img
                                src="@/assets/investor-Relation/percent.png"
                                alt=""
                            />
                            <span>&nbsp;-18.8&nbsp;（-4.00%）</span>
                        </div>
                    </div>
                    <div class="img">
                        <img
                            src="@/assets/investor-Relation/stock.png"
                            alt=""
                        />
                    </div>
                </div> -->
            </div>
        </div>
        <!--菜单五内容-->
        <div class="wrap nav-five">
            <div class="title">
                CORPORATE GOVERNANCE<span class="rl">
                    <!-- <router-link :to="{ path: '/governanceDocuments' }">
                        <img
                            src="@/assets/investor-Relation/more.png"
                            alt=""
                        /><span class="more">Read more</span>
                    </router-link> -->
                </span>
            </div>
            <div class="governance">
                <div class="caption">LEADERSHIP</div>
                <div class="content">
                    <div class="left-person">
                        <div class="person">
                            <img src="@/assets/about/person-one.png" alt="" />
                        </div>
                        <div class="news">
                            <!-- <div>
                                <span class="name">Alex Xu</span
                                ><span class="ceo">Chairman of the Board and CEO</span>
                            </div>
                            <div class="main-one">
                                A gaming veteran with over 28 years of industry experience, and one of the first entrepreneurs in gaming industry in China
                            </div>
                            <div class="main-two">
                                Track record of acquisitions of/investments into multiple renowned video gaming companies in the US and Europe and successful post-acquisition integration and value growth
                            </div> -->


                            <!-- <div
                                class="last-screen"
                                style="color: #333333;
                            font-size: 13px;
                            padding-right: 10px;line-height: 22px;"
                                v-html="
                                    corporateList
                                        ? corporateList.explain.length > 620
                                            ? corporateList.explain.substring(
                                                  0,
                                                  620
                                              ) + ' '
                                            : corporateList.explain
                                        : ''
                                "
                            ></div> -->
                            <div class="last-screen" style="color: #333333; font-size: 13px; padding-right: 10px;line-height: 22px;">
                                <div>
                                    <div>
                                        <p>
                                            <span class="name"><strong>Yiran Xu (Alex)</strong></span><span class="ceo">&nbsp;&nbsp; <span style="color:#999999;">Chairman of the Board and CEO</span></span> 
                                        </p>
                                        <br />
                                    </div>
                                    <div style="padding-top: 0px;">
                                        <p>A gaming veteran with over 28 years of industry experience, and one of the first entrepreneurs in gaming industry in China</p>
                                        <br/>
                                        <p>Track record of acquisitions of/investments into multiple renowned video gaming companies in the US and Europe and successful post-acquisition integration and value growth</p>
                                    </div>
                                </div>
                            </div>
                            <div class="more">
                                <router-link :to="{ path: '/leadership' }">
                                    <img
                                        src="@/assets/investor-Relation/more.png"
                                        alt=""
                                    /><span>Read more</span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="right-link">
                        <div class="link-one">
                            <router-link :to="{ path: '/governanceDocuments' }">
                                <span>Board of Directors</span>
                            </router-link>
                        </div>
                        <div class="link-two">
                            <router-link
                                :to="{ path: '/committeeComposition' }"
                            >
                                <span>Corporate Governance</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "investorRelation",
    components: { footerBox, navBox, subNav, mapBox },
    data() {
        return {
            eventsList: [],
            releasesList: [],
            reportsList: [],
            financialList: [],
            financial:{},
            corporateList: {
                explain: "",
            },
            loading: false,
        };
    },
    created() {
        this.loading = true;
        this.$http.getIrIndex().then((res) => {
            this.eventsList = res.events;
            this.releasesList = res.releases;
            this.reportsList = res.reports;
            this.financial = res.financial;
            for(let i in res.financial){
                for(let j in res.financial[i]){
                    this.financialList.push({
                        time:i+'-'+j
                    })
                }
            }
            this.corporateList = res.corporate;
            this.loading = false;
        });
    },
    methods: {
        getFile(url) {
            var site = url.lastIndexOf(".");
            return url.substring(site + 1, url.length);
        },
    },
};
</script>
<style lang="less" scoped>

.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.clear{
    clear: both;
}

//内容
.title {
    font-size: 30px;
    color: #333333;
    font-weight: bold;
    padding: 70px 0 50px 0;
    .rl {
        float: right;
        cursor: pointer;
        .more {
            color: #666666;
            font-size: 12px;
            border-bottom: 1px solid #a9a9a9;
            font-weight: 400;
            margin-left: 5px;
            position: relative;
            top: -15px;
        }
    }
}

//内容一
.nav-zero{
    margin-top: 30px;
    padding-bottom: 60px;
}

.Ir-homepage-body {
    border: solid 1px #CCCCCC;
    .irpagedata{
        width: 38%;
        float: left;
        margin-left: 60px;
        p{
            font-size: 14px;
            line-height: 28px;
            padding: 15px 5px 15px 15px;
        }
        .nav-zero-title {
            padding: 20px 0px 0px 0px;
            font-size: 18px;
            font-weight: bold;
        }
    }
    .irqmode-1{
        width: 50%;
        padding: 50px 0px 0px 20px;
        float: left;
        font-size: 16px;
        line-height: 18px;
    }
}

.nav-one {
    display: none;
    ul {
        filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
        -moz-box-shadow: 2px 2px 10px #909090;
        -webkit-box-shadow: 2px 2px 10px #909090;
        box-shadow: 2px 2px 10px #909090;
        li {
            height: 90px;
            cursor: pointer;
            > div {
                display: inline-block;
                margin-top: 15px;
            }
            .num {
                width: 26px;
                height: 18px;
                text-indent: 5px;
                font-size: 12px;
                background: url("../../assets/investor-Relation/title.png")
                    no-repeat;
                color: #ffffff;
                margin: 0 25px 0 30px;
            }
            .caption {
                font-size: 16px;
                color: #333333;
                position: relative;
                top: 15px;
                font-family: 'Lucida Bright';
            }
            .date {
                font-size: 13px;
                color: #888888;
                position: relative;
                top: 15px;
            }
            .pdf {
                margin-left: 20px;
                img {
                    width: 22px;
                    height: 25px;
                }
            }
            .down {
                float: right;
                padding-right: 30px;
                position: relative;
                top: 10px;
                display: none;
            }
        }
    }
}
.nav-one ul li:hover {
    background: #f6f6f6;
}
.nav-one ul li:hover .down {
    display: block;
}
//内容二
.nav-two {
    display: none;
    min-height: 280px;
    background: #f6f6f6;
    margin-top: 95px;
    .press {
        border: 1px solid #dcdcdc;
        background: #ffffff;
        ul {
            width: 100%;
            margin: 0 20px;
            display: flex;
            flex-wrap: wrap;
            li {
                height: 85px;
                border-bottom: 1px solid #e9e9e9;
                width: 47%;
                margin-right: 2%;
                .caption {
                    font-size: 20px;
                    color: #333333;
                    position: relative;
                    top: 18px;
                }
                .date {
                    font-size: 13px;
                    color: #888888;
                    position: relative;
                    top: 18px;
                }
            }
            li:last-child {
                border-bottom: none;
            }
            li:nth-last-child(2) {
                border-bottom: none;
            }
            .borderNone2 {
                border-bottom: 1px solid #e9e9e9 !important;
                font-family: 'Lucida Bright';
            }
            .borderNone2:last-child {
                border-bottom: none !important;
            }
            .borderNone {
                border-bottom: 1px solid #e9e9e9 !important;
                font-family: 'Lucida Bright';
            }
            .borderNone:last-child {
                border-bottom: 1px solid #e9e9e9 !important;
            }
        }
    }
}
//内容三
.nav-three {
    padding-bottom: 105px;
    display: none;
    .reports {
        display: flex;
        .caption {
            color: #444444;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 28px;
        }
        .left-content {
            width: 565px;
            padding-right: 75px;
            ul {
                width: 565px;
                filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
                -moz-box-shadow: 2px 2px 10px #909090;
                -webkit-box-shadow: 2px 2px 10px #909090;
                box-shadow: 2px 2px 10px #909090;
                li {
                    display: flex;
                    height: 87px;
                    align-items: center;
                    padding-right: 20px;
                    cursor: pointer;
                    .num {
                        width: 40px;
                        height: 18px;
                        text-indent: 5px;
                        font-size: 12px;
                        background: url("../../assets/investor-Relation/title.png")
                            no-repeat;
                        color: #ffffff;
                        margin: 0 25px 0 30px;
                    }
                    .sub-caption {
                        color: #333333;
                        font-size: 16px;
                        font-family: 'Lucida Bright';
                    }
                    .date {
                        color: #888888;
                        font-size: 13px;
                    }
                }
            }
        }
        .right-content {
            .financial {
                display: flex;
                .time-line {
                    width: 70px;
                    height: 180px;
                    position: relative;
                    top: 50px;
                    .line {
                        display: inline-block;
                        width: 1px;
                        height: 180px;
                        background: #dcdcdc;
                    }
                    .dot {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        position: absolute;
                        top: 0;
                        left: -3px;
                        background: #dcdcdc;
                    }
                    .date {
                        position: absolute;
                        top: 0;
                        left: 20px;
                        color: #888888;
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
                .date-year {
                    width: 525px;
                    ul {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        li {
                            width: 220px;
                            height: 120px;
                            margin: 0 35px 20px 0;
                            filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
                            -moz-box-shadow: 2px 2px 10px #909090;
                            -webkit-box-shadow: 2px 2px 10px #909090;
                            box-shadow: 2px 2px 10px #909090;
                            .current {
                                font-size: 28px;
                                font-style: oblique;
                                position: relative;
                                top: 20px;
                                padding-left: 20px;
                                font-family: 'Lucida Bright';
                            }
                            .year {
                                background: url("../../assets/investor-Relation/year.png")
                                    no-repeat;
                                color: #ffffff;
                                width: 51px;
                                height: 18px;
                                line-height: 14px;
                                position: relative;
                                top: 15px;
                                margin-left: 10px;
                                text-indent: 5px;
                                display: inline-block;
                                font-family: 'Lucida Bright';
                            }
                            .date {
                                position: relative;
                                top: 20px;
                                color: #888888;
                                font-size: 13px;
                                padding-left: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
.nav-three .reports .left-content ul li:hover {
    background: #f6f6f6;
}
//内容四
.nav-four {
    background: #f6f6f6;
    min-height: 275px;
    display: none;
    .price {
        display: flex;
        .stock {
            width: 385px;
            height: 400px;
            border: 1px solid #dfdfdf;
            background: #ffffff;
            margin-right: 10px;
            text-align: center;
            .real {
                margin: 125px 0 50px 0;
                color: #666666;
                font-size: 14px;
            }
            .hkd {
                color: #333333;
                font-size: 14px;
            }
            .num {
                color: #444444;
                font-size: 36px;
                font-weight: bold;
            }
            .percent {
                margin-top: 30px;
                color: #f43b00;
                font-size: 14px;
            }
        }
        .img {
            width: 810px;
            height: 400px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
//内容五
.nav-five {
    padding-bottom: 105px;
    display: none;
    .governance {
        .caption {
            color: #444444;
            font-weight: bold;
            font-size: 18px;
            margin-bottom: 30px;
        }
        .content {
            display: flex;
            .left-person {
                width: 750px;
                height: 255px;
                display: flex;
                border: 1px solid #dfdfdf;
                .person {
                    img {
                        width: 185px;
                        // height: 235px;
                        position: relative;
                        top: 20px;
                    }
                }
                .news {
                    margin-top: 25px;
                    .last-screen{
                        font-family: 'Lucida Bright';
                        /deep/.name {
                            color: #283254;
                            font-size: 26px;
                            font-family: 'Microsoft PhagsPa';
                        }
                        /deep/.ceo {
                            color: #888888;
                            font-size: 14px;
                            margin-left: 20px;
                            font-family: 'Microsoft PhagsPa';
                        }
                        /deep/.main-one{
                            margin-top: 17px;
                            color: #333333;
                            font-size: 13px;
                            padding-right: 10px;
                        }
                        /deep/.main-two {
                            margin-top: 17px;
                            color: #333333;
                            font-size: 13px;
                            padding-right: 10px;
                        }
                     }
                    .more {
                        margin-top: 15px;
                        cursor: pointer;
                        span {
                            color: #666666;
                            font-size: 12px;
                            border-bottom: 1px solid #a9a9a9;
                            margin-left: 5px;
                        }
                    }
                   
                }
            }
            .right-link {
                margin-left: 30px;
                .link-one,
                .link-two {
                    width: 420px;
                    height: 127px;
                    line-height: 127px;
                    text-align: center;
                    color: #283254;
                    font-size: 18px;
                    font-weight: bold;
                }
                .link-one {
                    border: 1px solid #dfdfdf;
                    border-bottom: none;
                }
                .link-two {
                    border: 1px solid #dfdfdf;
                }
            }
        }
    }
}
.nav-five .governance .right-link span:hover {
    border-bottom: 2px solid #3e4662;
    cursor: pointer;
}
.update {
    text-align: center;
    min-height: 100px;
    line-height: 200px;
    font-size: 30px;
    font-weight: bold;
    color: gray;
    font-family: 'Lucida Bright';
}



.qmod-detailedquote .qmod-quotegrid .qmod-label {
              color: #212529;
            }

            .qmod-hbg {
              background-color: transparent;
            }

            h2.qmod-heading {
              display: none;
            }

            .qmod-btn.qmod-btn-active {
              background-color: #2a275a;
              color: white;
            }

            .qmod-btn {
              background-color: #f5f5f5;
              border-color: white;
            }

            .qmod-button-group li {
              border-color: white;
            }

            .qmod-detailedquote .qmod-quotegrid .qmod-line-sep {
              padding: 10px 0;
            }

            .qmod-detailedquote .qmod-block-wrapper .pure-u-md-1-2 {
              width: 100%;
            }

            .qmod-detailedquote .qmod-block-wrapper .pure-g>.pure-u-md-1-2:nth-of-type(2) {
              margin-top: 3rem;
            }
</style>
